import { Form } from "antd";
import { HeaderOverview } from "components";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { VehicleData } from "service/dashboard/interface";
import { useGetPropertyDashboardVehicle } from "service/dashboard/property/vehicle";
import {
  ErrorDashboard,
  LoadingDashboard,
  NoDataDashboard,
  WrapperBG,
} from "../..";

const VehicleUse = () => {
  const { t } = useTranslation();
  const { findDate } = useOverview();

  const mostUsedVehicleDate = Form.useWatch("mostUsedVehicleDate");
  const date = findDate(mostUsedVehicleDate);

  const { data, isFetching, isError, error } = useGetPropertyDashboardVehicle({
    ...date,
  });


  const vehicleTypeMap: Record<string, string> = {
    CAR: t("car"),
    MOTORCYCLE: t("motorcycle"),
    BICYCLE: t("bicycle"),
    OTHER: t("other"),
  };
  

  return (
    <WrapperBG className="h-full">
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("most-used-vehicle-types")}
          name="mostUsedVehicleDate"
        />
        {isError ? (
          <ErrorDashboard error={error} height="250px" />
        ) : !data ? (
          <NoDataDashboard height="250px" />
        ) : (
          <div className="h-[250px] flex-col px-4">
          {data?.map((item: VehicleData) => (
            <div key={item.types} className="flex justify-between p-2 ">
              <div className="text-[1.5rem] text-[#44955B]">{vehicleTypeMap[item.types]}</div>
              <div className="text-[1.5rem] text-[#44955B]">{`${item.count}`}</div>
            </div>
          ))}
        </div>
        )}
      </LoadingDashboard>
    </WrapperBG>
  );
};

export default VehicleUse;
